import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import BumpIcon from '../public/static/images/item/promotion.svg';
import VipIcon from '../public/static/images/item/vip.svg';
import FeatureIcon from '../public/static/images/item/feature.svg';
import { selectSuccessPromotionModalViewState } from '../store/selectors';

export default () => {
  const { t } = useTranslation();
  const { isVisible: isOpenSuccessAlertModal, name } = useSelector(
    selectSuccessPromotionModalViewState
  );
  const onAcceptSuccessPaymentModalTerms = () => {
    window.location.reload();
  };
  const getSuccessAlertModalIcon = () => {
    switch (true) {
      case name === 'bump':
        return BumpIcon;
      case name === 'vip':
        return VipIcon;
      case name === 'feature':
        return FeatureIcon;
      default:
        return null;
    }
  };
  const getSuccessAlertModalTitle = () => {
    switch (true) {
      case name === 'bump':
        return t('pages.current_item.alert_modal.bumped_success_title');
      case name === 'vip':
        return t('pages.current_item.alert_modal.viped_success_title');
      case name === 'feature':
        return t('pages.current_item.alert_modal.featured_success_title');
      case name === 'restore':
        return t('pages.current_item.alert_modal.restore_success_title');
      case name === 'limit_payment':
        return t('pages.current_item.alert_modal.awaiting_payment_title');
      default:
        return '';
    }
  };

  const getSuccessAlertModalMessage = () => {
    switch (true) {
      case name === 'bump':
        return t('pages.current_item.promotion.raise_ad_info');
      case name === 'vip':
        return t('pages.current_item.promotion.make_vip_info');
      case name === 'feature':
        return t('pages.current_item.promotion.make_premium_info_alert');
      case name === 'restore':
        return t('pages.current_item.alert_modal.restore_success_message');
      case name === 'limit_payment':
        return t('pages.current_item.alert_modal.awaiting_payment_message');
      default:
        return '';
    }
  };
  const successAlertModalIcon = getSuccessAlertModalIcon();
  const successAlertModalTitle = getSuccessAlertModalTitle();
  const successAlertModalMessage = getSuccessAlertModalMessage();

  return {
    isOpenSuccessAlertModal,
    onAcceptSuccessPaymentModalTerms,
    successAlertModalIcon,
    successAlertModalTitle,
    successAlertModalMessage
  };
};
